import React from 'react';
import { FormattedMessage } from "react-intl";
import './FormFieldValidationError';

const FormFieldValidationError = (props) => {
    if (props.errors !== "") {
        return (
            <p className="error-message">
                <FormattedMessage id={props.errors}
                    defaultMessage="Error"
                    description="" />
            </p>
        )
    }
    return null;
};

export default FormFieldValidationError;



// WEBPACK FOOTER //
// ./src/components/Common/FormFieldValidationError/FormFieldValidationError.js